import { render, staticRenderFns } from "./OrganizationInviteModal.vue?vue&type=template&id=54c9923d&scoped=true"
import script from "./OrganizationInviteModal.vue?vue&type=script&lang=js"
export * from "./OrganizationInviteModal.vue?vue&type=script&lang=js"
import style0 from "./OrganizationInviteModal.vue?vue&type=style&index=0&id=54c9923d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9923d",
  null
  
)

export default component.exports